<template>
  <div class="project-loading" v-show="isShow" @scroll.stop>
    <div class="loading-wrapper">
      <span class="loading-dot loading-dot-spin">
        <i></i>
        <i></i>
        <i></i>
        <i></i>
      </span>
      <p class="loading-text">{{ msg }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingPlus",
  data() {
    return {
      msg: "",
      isShow: false
    }
  },
  methods: {
    /**
     * @description: 展示
     * @param {Number} duration 延迟关闭时间
     * @return: \
     * @author: guoruliang
     */
    show(msg = "", duration = 0) {
      this.msg = msg
      this.isShow = true
      if (!duration) {
        return
      }
      setTimeout(() => {
        this.isShow = false
      }, duration)
    },
    /**
     * @description: 隐藏
     * @param \
     * @return: \
     * @author: guoruliang
     */
    hide() {
      this.msg = ""
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>

.loading-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
  z-index: 9999;
}

.loading-dot {
  animation: antRotate 1.2s infinite linear;
  transform: rotate(45deg);
  position: relative;
  display: inline-block;
  font-size: 64px;
  width: 37px;
  height: 37px;
  box-sizing: border-box
}

.loading-dot i {
  width: 15px;
  height: 15px;
  position: absolute;
  display: block;
  background: #4077F4;
  border-radius: 100%;
  transform: scale(.75);
  transform-origin: 50% 50%;
  opacity: .3;
  animation: antSpinMove 1s infinite linear alternate
}

.loading-dot i:nth-child(1) {
  top: 0;
  left: 0
}

.loading-dot i:nth-child(2) {
  top: 0;
  right: 0;
  -webkit-animation-delay: .4s;
  animation-delay: .4s
}

.loading-dot i:nth-child(3) {
  right: 0;
  bottom: 0;
  -webkit-animation-delay: .8s;
  animation-delay: .8s
}

.loading-dot i:nth-child(4) {
  bottom: 0;
  left: 0;
  -webkit-animation-delay: 1.2s;
  animation-delay: 1.2s
}

@keyframes antRotate {
  to {
    -webkit-transform: rotate(405deg);
    transform: rotate(405deg)
  }
}

@-webkit-keyframes antRotate {
  to {
    -webkit-transform: rotate(405deg);
    transform: rotate(405deg)
  }
}

@keyframes antSpinMove {
  to {
    opacity: 1
  }
}

@-webkit-keyframes antSpinMove {
  to {
    opacity: 1
  }
}
</style>